import React from 'react';
import Dialog from '../../GeneralDialog';
import useTranslations from '../../../hooks/useTranslations';
import {
  TextField,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider as MuiDivider
} from '@material-ui/core';
import styled from 'styled-components/macro';

const Label = styled(FormLabel)`
  && {
    font-weight: 500;
    margin: 0.8em 0;
    color: #000;
  }
`;

const Divider = styled(MuiDivider)`
  && {
    margin: 0.8em 0;
  }
`;

const AddReminderWizardView = props => {
  const t = useTranslations();

  return (
    <Dialog
      open={props.open}
      title="form-builder.reminders.newReminder.title"
      buttons={[
        {
          text: 'dialog.cancel',
          variant: 'outlined'
        },
        {
          text: 'form-builder.reminders.newReminder.confirmBtn',
          onClick: 'confirm'
          //   disabled: props.isConfirmDisabled
        }
      ]}
      maxWidth="md"
      confirmCancel
      noX
      disableBackdropClick
      handleConfirm={props.handleConfirm}
      handleClose={props.handleClose}
      isDirty={props.isWizardDirty}
    >
      <Label component="legend">
        {t('form-builder.reminders.newReminder.reminderName.title')}
      </Label>

      <TextField
        value={props.reminderTitle}
        onChange={e => {
          props.setReminderTitle(e.target.value);
          props.setIsWizardDirty(true);
        }}
        inputProps={{ maxLength: 180 }}
        error={props.showTitleError}
        onFocus={() => props.setShowTitleError(false)}
        data-testid="reminder-name-input"
        placeholder={t(
          'form-builder.reminders.newReminder.reminderName.placeholder'
        )}
        variant="outlined"
        size="small"
        fullWidth
        helperText={t(
          props.showTitleError
            ? 'form-builder.reminders.newReminder.reminderName.helperText.error'
            : 'form-builder.reminders.newReminder.reminderName.helperText'
        )}
      />

      <Divider />

      <Label component="legend">
        {t('form-builder.reminders.newReminder.reminderType.title')}
      </Label>
      <RadioGroup
        onChange={e => {
          props.setReminderType(e.target.value);
          props.setIsWizardDirty(true);
        }}
        value={props.reminderType}
      >
        <FormControlLabel
          value="date"
          control={<Radio color="primary" />}
          label={t(
            'form-builder.reminders.newReminder.reminderType.option.date'
          )}
        />
        <FormControlLabel
          value="status"
          control={<Radio color="primary" />}
          label={t(
            'form-builder.reminders.newReminder.reminderType.option.status'
          )}
        />
      </RadioGroup>
    </Dialog>
  );
};

export default AddReminderWizardView;
